// See BE: splash-commissioner-service/blob/master/src/modules/assets/constants.ts
import { CommissionerAssetType } from '~/domains/commissioner/interfaces/channel.interface';

export const assetConfig = {
  [CommissionerAssetType.AVATAR]: {
    mediaPath: 'commissioner/avatars',
    fileSizeLimit: {
      min: 0,
      max: 1 * 1024 * 1024, // 1 MB in bytes
    },
    fileDimensionLimit: {
      width: {
        min: null,
        max: null,
      },
      height: {
        min: null,
        max: null,
      },
      ratio: {
        min: 0.8,
        max: 1.2,
      },
    },
    suggestedDimension: {
      width: 256,
      height: 256,
    },

    mimeTypes: ['image/jpeg', 'image/png'],
    formats: ['png', 'jpg', 'jpeg'],
  },
  [CommissionerAssetType.BACKDROP]: {
    mediaPath: 'commissioner/backdrops',
    fileSizeLimit: {
      min: 0,
      max: 4 * 1024 * 1024, // 4 MB in bytes
    },
    fileDimensionLimit: {
      width: {
        min: null,
        max: null,
      },
      height: {
        min: null,
        max: null,
      },
      ratio: {
        min: 1.2,
        max: 2,
      },
    },
    suggestedDimension: {
      width: 2880,
      height: 170,
    },

    mimeTypes: ['image/jpeg', 'image/png'],
    formats: ['png', 'jpg', 'jpeg'],
  },
};
